import request from '@/utils/request'

/**
 * 请求资源列表
 * @param { Object } params 请求参数
 * @returns 资源列表
 */
export function resourceList(params) {
  return request({
    url: '/app/res/list',
    method: 'get',
    params: params
  })
}

export function resourceInfo(resourceId) {
  return request({
    url: '/app/res/info/' + resourceId,
    method: 'get'
  })
}

/**
 * 基本检索
 * @param {Object} keyword 关键词
 */
export function search(keyword) {
  return request({
    url: '/app/res/search',
    method: 'get',
    params: keyword
  })
}

/**
 * 高级检索
 * @param {Array} keyword 关键词数组
 */
export function advSearch(keywords, page, size) {
  return request({
    url: '/app/res/adv-search',
    method: 'post',
    data: { keywords: keywords, page: page, size: size }
  })
}
